import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant' //加载vant
import 'vant/lib/index.css' // 加载vant 样式
import VueRouter from 'vue-router'
import Home from '@/views/home'
import Counseling from '@/views/counseling'
import AboutUs from '@/views/AboutUs'
import './styles/index.css'
Vue.use(Vant) // 注册 vant组件库
Vue.config.productionTip = false
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/counseling',
    component: Counseling,
  },
  {
    path: '/AboutUs',
    component: AboutUs,
  },
]
const router = new VueRouter({
  routes,
})
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
